import { Language } from '@customer-portal/shared';

export class UpdateProfileLanguage {
  static readonly type = '[Profile] Update Language';

  constructor(public portalLanguage: Language) {}
}

export class UpdateProfileLanguageSuccess {
  static readonly type = '[Profile] Update Language Success';

  constructor(public portalLanguage: Language) {}
}

export class UpdateProfileLanguageError {
  static readonly type = '[Settings] Update Profile Language Error';
}

export class SetProfileLanguage {
  static readonly type = '[Profile] Set Language';

  constructor(public portalLanguage: string) {}
}
